const state = {
  dialog: false,
}
const mutations = {
  SHOW_IDLE_ALERT: (state) => {
    state.dialog = true;
  },
  HIDE_IDLE_ALERT: (state) => {
    state.dialog = false;
  }
}
const actions = {
  showIdleDialog: (context,) => {
    context.commit("SHOW_IDLE_ALERT");
  },
  hideIdleDialog: (context) => {
    context.commit("HIDE_IDLE_ALERT");
  }
}
const getters = {}

export default {
  state,
  mutations,
  actions,
  getters
}